import React from 'react'
import { createBehavior, createResource } from '@designable/core'
import { createFieldSchema } from '../Field'
import { AllSchemas } from '../../schemas'
import { AllLocales } from '../../locales'
import { DnFC } from '../../../react'
import {NormalUpload as FormaticUpload } from './UploadComponent'

export const NormalUpload: DnFC<React.ComponentProps<typeof FormaticUpload>> =
FormaticUpload

NormalUpload.Behavior = createBehavior(
  {
    name: 'NormalUpload',
    extends: ['Field'],
    selector: (node) => node.props?.['x-component'] === 'NormalUpload',
    designerProps: {
      propsSchema: createFieldSchema(AllSchemas.NormalUpload),
    },
    designerLocales: AllLocales.NormalUpload,
  },
  // {
  //   name: 'Upload.Dragger',
  //   extends: ['Field'],
  //   selector: (node) => node.props?.['x-component'] === 'Upload.Dragger',
  //   designerProps: {
  //     propsSchema: createFieldSchema(AllSchemas.Upload.Dragger),
  //   },
  //   designerLocales: AllLocales.UploadDragger,
  // }
)

NormalUpload.Resource = createResource(
  {
    icon: 'UploadSource',
    elements: [
      {
        componentName: 'Field',
        props: {
          type: 'Array<object>',
          title: 'Upload',
          'x-decorator': 'FormItem',
          'x-component': 'NormalUpload',
          'x-component-props': {
            textContent: 'Upload',
            "destinationPath": "{{'Underwriting/NonMotor/Quotations'/customer_files/'}}"

          },
        },
      },
    ],
  }
)
